import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { NO_META } from "@/constants";

import { getTeam } from "@services/http/members";

import { ListTeamsStoreActions, ListTeamsStoreProps } from "./ListTeams.types";

export const useTeamsStore = create<ListTeamsStoreProps & ListTeamsStoreActions>()(
  devtools((set, get) => ({
    teamList: [],
    meta: NO_META,
    params: {
      page: 1,
      pageSize: 10,
    },
    isLoading: false,

    setTeams: (data, metaData) => set({ teamList: data, meta: metaData }),

    fetchTeam: async incomingParams => {
      set({ isLoading: true });

      const { params } = get();

      try {
        const { data: response } = await getTeam({
          page: params.page,
          pageSize: params.pageSize,
          search: params.search,
          ...incomingParams,
        });
        set({ teamList: response.data, meta: response.meta });
      } catch (error) {
        set({ teamList: [], meta: NO_META });
      } finally {
        set({ isLoading: false });
      }
    },

    paginate: page => {
      const { params, fetchTeam } = get();
      set({ params: { ...params, page } });
      fetchTeam();
    },

    search: query => {
      const { params, fetchTeam } = get();
      set({ params: { ...params, search: query } });
      query.length === 0 && set({ params: { ...params, search: undefined } });
      fetchTeam();
    },

    setIsLoading: state => set({ isLoading: state }),

    resetParams: incomingParams => {
      const { params } = get();
      set({ params: { ...params, ...incomingParams } });
    },
  }))
);
